import { queryOptions, useQuery } from '@tanstack/vue-query';
import type { ApiPaginatedResponse } from '@/types';
import type { ApiNewsPage } from '@/types/pages/news';

export function getLatestNewsPage(data: ApiPaginatedResponse<ApiNewsPage> | undefined) {
  return data?.items[0];
}

export function latestNewsQueryOptions() {
  const { cmsFetch } = useCms();
  return queryOptions({
    queryKey: ['cms', 'pages', 'news', 'latest'] as const,
    queryFn: () => cmsFetch<ApiPaginatedResponse<ApiNewsPage>>('/api/pages/', {
      type: 'pages.NewsPage',
      fields: '*',
      order: '-first_published_at',
      limit: 1,
    }),
  });
}

export function useLatestNews() {
  return useQuery(latestNewsQueryOptions());
}

export function newsListQueryOptions() {
  const { cmsFetch } = useCms();
  return queryOptions({
    queryKey: ['cms', 'pages', 'news'] as const,
    queryFn: () => cmsFetch<ApiPaginatedResponse<ApiNewsPage>>('/api/pages/', {
      type: 'pages.NewsPage',
      fields: '*',
      order: '-first_published_at',
    }),
  });
}

export function useNewsList() {
  return useQuery(newsListQueryOptions());
}

export function newsArticleQueryOptions(id: number) {
  const { cmsFetch } = useCms();
  return queryOptions({
    queryKey: ['cms', 'pages', 'news', id] as const,
    queryFn: () => cmsFetch<ApiNewsPage>(`/api/pages/${id}/`, { fields: '*' }),
  });
}

export function useNewsArticle(id: MaybeRefOrGetter<number | undefined>) {
  const { cmsFetch } = useCms();
  return useQuery({
    queryKey: computed(() => ['cms', 'pages', 'news', toValue(id)] as const),
    queryFn: () => cmsFetch<ApiNewsPage>(`/api/pages/${toValue(id)}/`, { fields: '*' }),
    enabled: computed(() => !!toValue(id)),
  });
}
